// Client-side downscale via canvas: full-size copy for OCR/archive + small thumb.
async function loadImage(file) {
  const url = URL.createObjectURL(file);
  try {
    const img = new Image();
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = () => reject(new Error("Couldn't read that image"));
      img.src = url;
    });
    return img;
  } finally {
    // revoke after draw — caller uses the Image synchronously right after
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  }
}

function toBlob(canvas, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("Image encode failed"))), "image/jpeg", quality);
  });
}

function draw(img, maxDim) {
  const scale = Math.min(1, maxDim / Math.max(img.naturalWidth, img.naturalHeight));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(img.naturalWidth * scale);
  canvas.height = Math.round(img.naturalHeight * scale);
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas;
}

// Returns { original: Blob (<=2000px, q0.85), thumb: Blob (<=320px, q0.7) }
export async function prepareReceiptImages(file) {
  const img = await loadImage(file);
  const original = await toBlob(draw(img, 2000), 0.85);
  const thumb = await toBlob(draw(img, 320), 0.7);
  return { original, thumb };
}

// Single square-ish downscale for contact photos / avatars.
export async function resizePhoto(file, maxDim = 512, quality = 0.8) {
  const img = await loadImage(file);
  return toBlob(draw(img, maxDim), quality);
}
